import { mapGetters } from 'vuex';
import periodMixin from './period.js';

export default {
    mixins: [periodMixin],
    props: {},
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: null
        };
    },
    computed: {
        ...mapGetters({
            getProductByName: 'products/productByName'
        }),
        /**
         * Returns which price we should display.
         *
         * @return {string}
         */
        displayPriceType() {
            return 'registration';
        },
        /**
         * Get the product by product plan name.
         *
         * @return {object}
         */
        product() {
            if (!this.productPlan) {
                return;
            }

            return this.getProductByName(this.productPlan.name);
        },
        /**
         * Get the product prices by type.
         *
         * @return {array}
         */
        productPrices() {
            if (!this.product) {
                return [];
            }

            return this.product.prices.filter(productPrice => productPrice.type == this.displayPriceType);
        },

        /**
         * Get the product prolongation prices.
         *
         * @return {array}
         */
        productProlongationPrices() {
            if (!this.product) {
                return [];
            }

            return this.product.prices.filter(productPrice => productPrice.type == 'prolongation');
        }
    }
};
